import { commonClientResx } from "~/resxDist/commonClientResx";
import { commonResx } from "~/resxDist/commonResx";
import { icon } from "~/sharedComponents/icons";
import { createButton } from "../Button";
import { ButtonFlag, ButtonVariants } from "../Enums";

/** 'Cancel' text by default */
export const ButtonCancel = createButton("ButtonCancel", { text: commonClientResx.Cancel });
/** Opacity 'Cancel' button */
export const ButtonTransparentCancel = createButton("ButtonDefault", {
    variant: ButtonVariants.Ghost,
    text: commonClientResx.Cancel,
    showTooltip: true,
});

/** Opacity button with text and icons */
export const ButtonDefault = createButton("ButtonDefault", {
    variant: ButtonVariants.Ghost,
    flags: ButtonFlag.Small,
    showTooltip: true,
});

/** 'Export' button with icon */
export const ButtonExport = createButton("ButtonExport", {
    variant: ButtonVariants.Ghost,
    flags: ButtonFlag.Small,
    showTooltip: true,
    iconName: icon.export,
    text: commonResx.export,
});

export const ButtonShare = createButton("ButtonShare", {
    variant: ButtonVariants.Ghost,
    iconName: icon.share,
    text: commonResx.share,
});
